import React from 'react';
import { empresaData } from '../data/mock';
import { CheckCircle } from 'lucide-react';

const Bienvenida = () => {
  const caracteristicas = [
    "Útiles de fijación y control",
    "Mecanizados de precisión",
    "Estándares IQNet y AENOR"
  ];

  return (
    <section id="nosotros" className="py-16 lg:py-24 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-10 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div>
            <span className="text-[#f4a261] font-semibold text-sm uppercase tracking-wider mb-3 block">Servicios Profesionales</span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Bienvenidos a Micro-Bat S.L.
            </h2>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Elaboramos útiles de fijación y control. Realizamos mecanizados de precisión mediante diferentes procesos y técnicas según estándares IQNet y AENOR.
            </p>

            {/* Features List */}
            <ul className="space-y-4 mb-8">
              {caracteristicas.map((item, index) => (
                <li key={index} className="flex items-center gap-3">
                  <CheckCircle className="text-[#0d3b66] flex-shrink-0" size={22} />
                  <span className="text-gray-700 font-medium">{item}</span>
                </li>
              ))}
            </ul>

            {/* CTA */}
            <button 
              onClick={() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' })}
              className="btn-primary"
            >
              Contactar
            </button>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-xl shadow-xl">
              <img
                src={empresaData.sitioImagen}
                alt="Instalaciones Micro-Bat"
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-[#0d3b66]/10 rounded-xl -z-10" />
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#f4a261]/20 rounded-xl -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Bienvenida;
